const SectionPanel = ({
  icon,
  title,
  onViewAll,
  children,
  empty,
  emptyText,
}) => (
  <div className="bg-bg-surface border border-border rounded-xl overflow-hidden">
    <div className="flex items-center justify-between px-5 py-4 border-b border-border">
      <div className="flex items-center gap-2">
        {icon}
        <h2 className="text-sm font-semibold text-text-primary">{title}</h2>
      </div>
      {onViewAll && (
        <button
          onClick={onViewAll}
          className="flex items-center gap-1 text-xs text-primary hover:opacity-80 transition"
        >
          View all <span className="text-xs">→</span>
        </button>
      )}
    </div>
    {empty ? (
      <div className="px-5 py-8 text-center">
        <p className="text-xs text-text-muted">
          {emptyText ?? "Nothing here yet"}
        </p>
      </div>
    ) : (
      children
    )}
  </div>
);

export default SectionPanel;
